import {
  deriveInternationalMobileDraft,
  resolveInternationalMobile,
} from '@/lib/phone/resolveInternationalMobile';
import type { HireClippersProfile } from './hireClippersDraft';
import type { HireClippersOrigin } from './hireClippersRoute';

/** The site's page for brands buying a clipping campaign. */
export const BRANDS_LANDING_URL = 'https://autoclipper.live/marcas';

function profilePhoneE164(phone: string | null | undefined): string | null {
  const draft = deriveInternationalMobileDraft(phone);
  if (!draft.valid) return null;
  return resolveInternationalMobile(draft)?.e164 ?? null;
}

/**
 * Link the "Contratar clipadores" entries open in a new tab. The account's
 * name, email and WhatsApp ride in the fragment, which the browser never
 * sends to a server; the site moves it out of the address bar before its
 * analytics load and pre-fills the /marcas/campanha contact step with it
 * (`../autoclipper-landing-page/src/lib/brand-lead-prefill.ts`).
 * `lead_source` keeps the lead counted as an app lead in /admin/contatos.
 */
export function buildBrandsLandingUrl(
  origin: HireClippersOrigin,
  profile: HireClippersProfile | null | undefined,
): string {
  const params = new URLSearchParams({ lead_source: `app:${origin}` });
  const name = profile?.name?.trim();
  const email = profile?.email?.trim();
  const phone = profilePhoneE164(profile?.phone_number);
  if (name) params.set('lead_name', name);
  if (email) params.set('lead_email', email);
  if (phone) params.set('lead_phone', phone);
  return `${BRANDS_LANDING_URL}#${params.toString()}`;
}
